<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.whCode" clearable="clearable">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.whName" clearable="clearable">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型" class="EL-Form-Item">
                        <el-select v-model="pagination.whType" >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="直材" value="10"></el-option>
                            <el-option label="间材" value="20"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="通道">
                <el-button v-authority="'BACK_MENU5_M5_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M5_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <!-- <el-table-column prop="whId" label="序号" /> -->
                <el-table-column prop="whCode" label="通道编号" />
                <el-table-column prop="whName" label="通道名称" />
                <!-- <el-table-column prop="whAlarmMax" label="上限值" />
                <el-table-column prop="whAlarmMin" label="下限值" /> -->
                <!-- <el-table-column prop="whVolume" label="通道最大容量" /> -->
                <el-table-column prop="whType" label="物料类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.whType == 10">直材</span>
                        <span v-if="scope.row.whType == 20">间材</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shareFlag" label="是否共享">
                    <template slot-scope="scope">
                        <span v-if="scope.row.shareFlag == true">是</span>
                        <span v-if="scope.row.shareFlag == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="productFlag" label="所有工单">
                  <template slot-scope="scope">
                    <span v-if="scope.row.productFlag == true">是</span>
                    <span v-if="scope.row.productFlag == false">否</span>
                  </template>
              </el-table-column>
                <el-table-column prop="sahreWh" label="共享通道" />
                <el-table-column prop="updateTime" label="更新时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M5_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M5_B3'" type="danger" @click="deleteRow(scope.row.whId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :style="$popups.popups(0.5,0.45)" class="fromDialog" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="通道编号" prop="whCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.whCode"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="通道名称" prop="whName" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.whName"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料类型" prop="whType" class="EL-Form-Item">
                            <el-select v-model="mainObj.whType" placeholder="请选择" clearable="clearable">
                                <el-option label="直材" value="10" />
                                <el-option label="间材" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="是否共享" prop="shareFlag" class="EL-Form-Item">
                            <el-select v-model="mainObj.shareFlag" placeholder="请选择" clearable="clearable">
                                <el-option label="是" :value="true" />
                                <el-option label="否" :value="false" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :lg="8" :xl="8">
                        <el-form-item label="是否所有工单" prop="productFlag" class="EL-Form-Item">
                            <el-select v-model="mainObj.productFlag" placeholder="请选择" clearable="clearable">
                                <el-option label="是" :value="true" />
                                <el-option label="否" :value="false" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                  <el-col :lg="8" :xl="8">
                        <el-form-item label="通道名称" prop="sahreWh" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.sahreWh"> </el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="8" :xl="8">
                        <el-form-item label="通道预警上限值" prop="whAlarmMax" class="EL-Form-Item">
                            <el-input v-model="mainObj.whAlarmMax" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :lg="8" :xl="8">
                        <el-form-item label="通道预警下限值" prop="whAlarmMin" class="EL-Form-Item">
                            <el-input v-model="mainObj.whAlarmMin" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :lg="8" :xl="8">
                        <el-form-item label="通道最大容量" prop="whVolume" class="EL-Form-Item">
                            <el-input v-model="mainObj.whVolume" oninput="value=value.replace(/[^\d]/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Warehouse",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    whCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    whName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    whType: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    shareFlag: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                  productFlag: [{
                    required: true,
                    message: "请选择",
                    trigger: "blur",
                  }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    fcCode: "",
                    whCode: "",
                    whName: "",
                    whType: "",
                },
				tableTotal:0,
                mainData: [],
                fcode: localStorage.getItem("fcCode") || "",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouseAll",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.tableTotal = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.fcode != "") {
                    this.mainObj.fcCode = this.fcode;
                }
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/warehouse/insertWarehouse",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "warehouse：通道新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "warehouse：通道新增失败";
                            }
                            this.logContent = "whCode：" + this.mainObj.whCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/warehouse/updateWarehouse",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "warehouse：通道修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "warehouse：通道修改失败";
                            }
                            this.logContent = "whCode：" + this.mainObj.whCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(whId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/warehouse/deleteWarehouse",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    whId: whId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "warehouse：通道删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "warehouse：通道删除失败";
                                }
                                this.logContent = "whId：" + whId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    fcCode: "",
                    whCode: "",
                    whName: "",
                };
				this.tableTotal=0;
                // this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.pagination.fcCode,
                    whCode: this.pagination.whCode,
                    whName: this.pagination.whName,
                    whType: this.pagination.whType,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/warehouse/getWarehouseAll',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.whType == "10") {
                            c['whType'] = '直材'
                        } else if (c.whType == "20") {
                            c['whType'] = '间材'
                        }
                    })
                    list.forEach(function(c) {
                        if (c.shareFlag == true) {
                            c['shareFlag'] = '是'
                        } else if (c.shareFlag == false) {
                            c['shareFlag'] = '否'
                        }
                    })
                    const tHeader = ['通道编号', '通道名称',  '物料类型',  '是否共享', '更新时间']
                    const filterVal = ['whCode', 'whName',  'whType', 'shareFlag', 'updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '通道数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_warehouse：导出通道数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "通道主数据",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>